<template>
  <div class="content-section" id="find-id-template">
    <div class="login-wrap" >
      <div class="login-area" v-show="!isFind">
        <div class="login-item">
          <div class="input-area">
            <p class="tit">
              <label for="name" class="">이름</label>
            </p>
            <input type="text" class="" title="이름을 입력해주세요." v-model="name" placeholder="이름" value="">
          </div>
        </div>
        <div class="login-item">
          <div class="input-area">
            <p class="tit">
              <label for="email" class="">이메일</label>
            </p>
            <input type="text" class="" title="이메일를 입력해주세요." v-model="email" placeholder="이메일" value="">
          </div>
        </div>
        <div class="login-item">
          <div class="input-area">
            <p class="tit">
              <label for="phone-number" class="">연락처</label>
            </p>
            <input type="text" class="" title="연락처를 입력해주세요." v-model="phone" placeholder="‘-’ 제외하고 숫자만 입력" value="">
          </div>
        </div>
        <div class="login-item">
          <div class="button-area">
            <button class="btn btn-primary btn-md" @click="findId">
              아이디 찾기
            </button>
          </div>
        </div>
        <div class="login-item">
          <div class="desc">
            아이디찾기 문의 : 운영지원팀(TEL : 1661-5516)
          </div>
        </div>
      </div>
      <div class="login-area" v-show="isFind">
        <div class="welcome-wrap">
          <div class="welcome-title">
            회원정보와 일치하는 아이디는<br>아래와 같습니다.
            <div class="data-match">
              <div class="matched-item">아이디</div>
              <div class="matched-text">
                <span v-for="(id, index) in resultIds" :key="index">
                  <span>{{id}}</span><span v-if="index+1 < resultIds.length">, </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="login-item">
          <div class="desc">
            아이디찾기 문의 : 운영지원팀(TEL : 1661-5516)
          </div>
        </div>
      </div>
      <div class="find-area">
        <a href="/login.do">로그인</a>
        <a href="reset-password.do">비밀번호 찾기</a>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'find-id',
    data() {
      return {
        resultIds: [],
        isFind: false,
        name: '',
        email: '',
        phone: '',
      };
    },
    methods: {
      findId() {
        const Params = {
          name: this.name,
          email: this.email,
          phone: this.phone,
        };
        Axios.post('/api/members/find-id', Params).then((res) => {
          this.resultIds = res.data;
          console.log('this.resultIds', this.resultIds);
          this.isFind = true;
        }).catch((e) => {
          alert(e.response.data.msg);
          this.isFind = false;
        });
      },
    },
  };

</script>


// WEBPACK FOOTER //
// FindIdJobType.vue?6c344115